import { BaseError, ContractFunctionRevertedError, UserRejectedRequestError } from "viem";

const FRIENDLY: Record<string, string> = {
  SpotOutOfBand: "The price moved since this quote. Get a fresh quote and try again.",
  OrderExpired: "This quote expired. Get a fresh one.",
  Overfilled: "Someone filled this quote first. Get a fresh one.",
  PremiumLimit: "The premium changed more than your limit.",
  BelowMinimum: "Not profitable after the swap right now. Nothing was spent.",
  NotProfitable: "This option is not in the money right now, so there is nothing to cash out.",
  PartialFill: "The pool is too thin to cash out this size in one go. Try a smaller amount.",
  Expired: "This series has expired.",
  SeriesExpired: "This series has expired.",
  CapExceeded: "This series is full for now.",
  SeriesCapExceeded: "The vault has sold all it can on this series for now.",
  FillTooLarge: "That is larger than the vault sells in one go. Try a smaller amount.",
  IsPaused: "Trading is paused for the moment.",
  Paused: "New positions are paused for the moment.",
  BadSignature: "This quote is no longer valid. Get a fresh one.",
  InsufficientShares: "You do not have enough written options to close that amount.",
  AlreadyClaimed: "Already claimed.",
  NotClaimable: "This payout opens a little later.",
  ERC1155InvalidReceiver: "Your wallet cannot receive ERC-1155 tokens (option contracts). Use a standard wallet.",
  ERC1155MissingApprovalForAll: "Approval needed first.",
  AbovePriceCap: "The vault's buyback price changed. Get a fresh price and try again.",
  NothingToClose: "The vault can't buy back that many on this series right now. Try a smaller amount.",
};

export function friendlyError(err: unknown): string {
  if (err instanceof BaseError) {
    if (err.walk((e) => e instanceof UserRejectedRequestError)) return "You rejected the request in your wallet.";
    const revert = err.walk((e) => e instanceof ContractFunctionRevertedError) as ContractFunctionRevertedError | null;
    const name = revert?.data?.errorName;
    if (name && FRIENDLY[name]) return FRIENDLY[name];
    if (name) return `Transaction would fail (${name}).`;
    if (/insufficient funds/i.test(err.message)) return "Not enough ETH in your wallet for this and gas.";
    return err.shortMessage || err.message;
  }
  return (err as Error)?.message ?? String(err);
}
